import React, { useContext, useState } from "react"
import { useHistory } from "react-router-dom"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { Button } from "../../components/common/button/Button"
import DealershipContent from "./DealershipContent"
import { useForm } from "react-hook-form"
import GAHiddenInputs from "../../components/common/gaHiddenInputs/gaHiddenInputs"

interface Props {
  dealershipGuidError?: boolean
  errorForNoDealershipGuid: (arg0: boolean) => void
}

export const RequestCall: React.FC<Props> = ({
  errorForNoDealershipGuid,
  dealershipGuidError,
}) => {
  const history = useHistory()
  const {
    state: { closestDealerships },
    api: { getValuation },
  } = useContext(AppContext) as AppContextInterface
  const { handleSubmit, register, errors } = useForm()
  const [hasPostCodeError, setHasPostCodeError] = useState(false)

  const onSubmit = () => {
    if (!dealershipGuidError && !hasPostCodeError) {
      getValuation(history)
    }
  }

  return (
    <>
      <p>Please enter your postcode to find a dealership so a member of the team can contact you.</p>
      <DealershipContent
        register={register}
        errors={errors}
        errorForNoDealershipGuid={errorForNoDealershipGuid}
        setHasPostCodeError={setHasPostCodeError}
      />
      {closestDealerships?.length ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <GAHiddenInputs />
          <Button type="submit" variant="blue" disabled={dealershipGuidError}>
            CONFIRM REQUEST FOR A CALL BACK
          </Button>
        </form>
      ) : null}
    </>
  )
}
